export function sliderGrab() {
    const sliders = document.querySelectorAll('.slider--grab');

    sliders.forEach(slider => {
        const container = slider.closest('.slider-container');
        if (!container) return;

        const leftArrow = container.querySelector('.slider-arrow--left');
        const rightArrow = container.querySelector('.slider-arrow--right');

        // Función para verificar el desbordamiento y mostrar/ocultar flechas
        const checkScroll = () => {
            if (slider.scrollWidth > slider.clientWidth) {
                container.classList.add('show-arrows');
            } else {
                container.classList.remove('show-arrows');
            }
        };

        checkScroll();
        window.addEventListener('resize', checkScroll);

        let isDown = false;
        let startX;
        let scrollLeft;

        slider.addEventListener('mousedown', (e) => {
            isDown = true;
            slider.classList.add('active');
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseleave', () => {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mouseup', () => {
            isDown = false;
            slider.classList.remove('active');
        });

        slider.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3;
            slider.scrollLeft = scrollLeft - walk;
        });

        //Funcionalidad de las flechas
        const scrollAmount = 200;
        if (leftArrow && rightArrow) {
            leftArrow.addEventListener('click', () => {
                slider.scrollTo({
                    left: slider.scrollLeft - scrollAmount,
                    behavior: 'smooth'
                });
            });

            rightArrow.addEventListener('click', () => {
                slider.scrollTo({
                    left: slider.scrollLeft + scrollAmount,
                    behavior: 'smooth'
                });
            });
        }

        const observer = new MutationObserver(checkScroll);
        observer.observe(slider, { childList: true });
    });
}